import * as Yup from 'yup';

export type TInitialValues = {
  email: string;
};

export const initialValues: TInitialValues = {
  email: '',
};

export const validation = Yup.object().shape({
  email: Yup.string()
    .email('Neplatný email')
    .required('Tento údaj je povinný'),
});